<template>
    <v-row justify="center">
        <v-dialog v-model="internalDialog" persistent max-width="500">
            <v-card>
                <v-card-title class="headline">
                    <span style="color: #d60000">{{ title }}</span>
                </v-card-title>
                <v-card-text>
                    <span style="color: #d60000">{{ message }}</span>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red accent-4" class="white--text" @click="handleCancel">
                        {{ cancelText }}
                    </v-btn>
                    <v-btn color="red accent-4" class="white--text" @click="handleConfirm">
                        {{ confirmText }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
export default {
    name: 'ConfirmDeleteDialog',
    props: {
        value: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ''
        },
        message: {
            type: String,
            default: ''
        },
        cancelText: {
            type: String,
            default: 'Cancelar'
        },
        confirmText: {
            type: String,
            default: 'Deletar'
        }
    },
    computed: {
        internalDialog: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            }
        }
    },
    methods: {
        handleCancel() {
            this.$emit('cancel');
            this.internalDialog = false;
        },
        handleConfirm() {
            this.$emit('confirm');
            this.internalDialog = false;
        }
    }
}
</script>

